<template>
  <div class="home">
    <el-row :gutter="20">
      <el-col
        :xs="{ offset: 0, span: 24 }"
        :sm="{ offset: 2, span: 20 }"
        :md="{ offset: 4, span: 16 }"
      >
        <h4>
          <template v-if="!user">
            <img alt="Vue logo" src="../assets/logo.svg" class="landing-img" />
            <br />
            <br />

            <span class="text-focus-in">
              Пут од хиљаду миља почиње једним кораком.
            </span>
            <br />
            <br />
            <el-button
              type="primary"
              @click="$router.push('register')"
              class="roll-in-blurred-left"
              >Направи налог
            </el-button>
          </template>

          <template v-else>
            <div class="action-buttons">
              <transition name="el-zoom-in-center">
                <router-link
                  :to="{ name: ROUTES.EXAMPLE_360_PAGE, params: { number: 1 } }"
                  class="el-button el-button--default"
                >
                  <img src="./../assets/play.svg" alt="play" />
                  <span class="btn-text"> 360° приказ </span>
                </router-link>
              </transition>

              <router-link
                :to="{
                  name: ROUTES.EXAMPLE_360_PAGE,
                  params: { number: 1 },
                  query: { vr: true },
                }"
                class="el-button el-button--default vr-button"
                v-if="isMobile"
              >
                <img src="./../assets/vr.svg" alt="vr" />
                <span class="btn-text">VR модул</span>
              </router-link>

              <router-link
                :to="{
                  name: ROUTES.TESTS_PAGE,
                }"
                class="el-button el-button--default quiz-button"
              >
                <img src="./../assets/test.svg" alt="play" />
                <span class="btn-text"> Тестови </span>
              </router-link>

              <router-link
                :to="{
                  name: ROUTES.SIGNS_QUESTIONS_PAGE,
                }"
                class="el-button el-button--default"
              >
                <i class="el-icon-success"></i>
                <span class="btn-text"> Знакови </span>
              </router-link>

              <router-link
                :to="{
                  name: ROUTES.INFO_PAGE,
                }"
                class="el-button el-button--default"
              >
                <i class="el-icon-info"></i>
                <span class="btn-text"> Више </span>
              </router-link>
              <!-- <el-button
              icon="el-icon-info"
              @click="toggleShowInfo"
            >
            Више
            </el-button> -->

              <!-- <transition
                name="fade-enter"
                mode="out-in"
             >
                <span
                  v-if="showInfo"
                  class="app-info"
                >
                Добродошли у интерактивни водич кроз саобраћај.
                Упустите се у мноштво реалних примера који на
                крајње интересантан начин имају за циљ да допринесу
                већој свести о важности познавања саобраћајних
                прописа.
                Едукација младих је један од најважнијих циљева
                Обазривка, који је још увек у фази развоја, тако
                да молимо вас за било какву повратну информацију о
                проблемима на које сте наишли или захтевима за даљи
                развој
                <a href="mailto:obazrivko@gmail.com">(obazrivko@gmail.com)</a>.
                </span>
              </transition> -->
            </div>
          </template>
        </h4>
      </el-col>
    </el-row>

    <div class="background-credit">
      <a
        href="https://www.flickr.com/photos/chrisandhilleary/206336624/"
        target="_blank"
        >Signs</a
      >
      (<a
        rel="license"
        href="https://creativecommons.org/licenses/by-sa/2.0/"
        target="_blank"
        >CC BY-SA 2.0</a
      >) by
      <a
        xmlns:cc="http://creativecommons.org/ns#"
        rel="cc:attributionURL"
        property="cc:attributionName"
        href="https://www.flickr.com/people/chrisandhilleary/"
        target="_blank"
        >C+H</a
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MobileDetect from "mobile-detect";
import * as ROUTES from './../routes/routes';
// import ElPopover from 'element-ui/lib/popover';
// import MessageBox from 'element-ui/lib/message';

export default {
  name: "home",
  data() {
    return {
      isMobile: false,
      showInfo: false,
      ROUTES
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
  },
  methods: {
    toggleShowInfo() {
      this.showInfo = !this.showInfo;
    },
  },
  mounted() {
    const mobileDetect = new MobileDetect(window.navigator.userAgent);
    this.isMobile = mobileDetect.mobile();
  },
};
</script>

<style lang="scss">
.home {
  width: 100%;
}

/* ----------------------------------------------
 * Generated by Animista on 2019-7-5 17:26:33
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation puff-in-center
 * ----------------------------------------
 */
@-webkit-keyframes puff-in-center {
  0% {
    -webkit-transform: scale(2);
    transform: scale(2);
    -webkit-filter: blur(2px);
    filter: blur(2px);
    opacity: 0;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
@keyframes puff-in-center {
  0% {
    -webkit-transform: scale(2);
    transform: scale(2);
    -webkit-filter: blur(2px);
    filter: blur(2px);
    opacity: 0;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}

/**
 * ----------------------------------------
 * animation text-focus-in
 * ----------------------------------------
 */
@-webkit-keyframes text-focus-in {
  0% {
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
@keyframes text-focus-in {
  0% {
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}

/**
 * ----------------------------------------
 * animation roll-in-blurred-left
 * ----------------------------------------
 */
@-webkit-keyframes roll-in-blurred-left {
  0% {
    -webkit-transform: translateX(-1000px) rotate(-720deg);
    transform: translateX(-1000px) rotate(-720deg);
    -webkit-filter: blur(50px);
    filter: blur(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0) rotate(0deg);
    transform: translateX(0) rotate(0deg);
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
}
@keyframes roll-in-blurred-left {
  0% {
    -webkit-transform: translateX(-1000px) rotate(-720deg);
    transform: translateX(-1000px) rotate(-720deg);
    -webkit-filter: blur(50px);
    filter: blur(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0) rotate(0deg);
    transform: translateX(0) rotate(0deg);
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
}

/**
 * ----------------------------------------
 * animation scale-in-center
 * ----------------------------------------
 */
@-webkit-keyframes scale-in-center {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes scale-in-center {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
}

.landing-page {
  .el-main {
    background-image: linear-gradient(
        rgba(248, 248, 248, 0.763),
        rgba(21, 151, 226, 0.685)
      ),
      url("./../assets/background.jpg");
    background-size: cover;
    background-repeat: no-repeat;
  }
}

.background-credit {
  font-size: 0.7rem;
  position: absolute;
  bottom: 70px;
  color: #fff;

  a {
    color: #fff;
  }
}

.action-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media screen and (max-width: 600px) {
    flex-direction: column;
    .el-button {
      margin-left: 30% !important;
      margin-right: 30% !important;
      margin-bottom: 5%;
      background: #409eff;
    }
  }
  .el-button {
    color: #fff;
    border: none;
    background: #409eff;
    text-decoration: none;
    line-height: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    -webkit-animation: scale-in-center 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
      both;
    animation: scale-in-center 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;

    &:hover,
    &:active,
    &:focus {
      background: #409eff;
      color: #fff;
    }

    img {
      width: 50px;
      height: 50px;
      color: red;
    }

    i {
      font-size: 50px;
    }
  }
  .app-info {
    padding-top: 2rem;
    text-align: justify;
  }
}

.landing-img {
  -webkit-animation: puff-in-center 1s cubic-bezier(0.47, 0, 0.745, 0.715) both;
  animation: puff-in-center 1s cubic-bezier(0.47, 0, 0.745, 0.715) both;
}

.text-focus-in {
  -webkit-animation: text-focus-in 2s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  animation: text-focus-in 2s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
}

.roll-in-blurred-left {
  -webkit-animation: roll-in-blurred-left 3s cubic-bezier(0.23, 1, 0.32, 1) both;
  animation: roll-in-blurred-left 3s cubic-bezier(0.23, 1, 0.32, 1) both;
}

.vr-button {
  display: flex !important;

  span {
    display: flex;
  }
  img {
    width: 20px;
    height: 20px;
  }
  .btn-text {
    margin-left: 10px;
    line-height: 20px;
  }
}

.quiz-button {
  img {
    width: 50px;
    height: 50px;
  }
}
</style>